<template>
  <div>
    <!-- Begin User Profile modal -->
    <v-navigation-drawer v-if="isOpen" v-model="isOpen" temporary fixed right width="500">
      <DrawerToolbar title="My Account" @close="isOpen = false" />
      <v-row justify="center" class="py-14">
        <v-col cols="7" sm="7" md="7" lg="7">
          <v-img
            v-if="userProfile.profilePicUrl !== null"
            :src="userProfile.profilePicUrl"
            :aspect-ratio="1 / 1"
            :width="profileImageWidth"
            :height="profileImageHeight"
            class="circle-border-radius mx-auto profile-picture"
          />
          <v-icon v-else x-large class="profile-picture circle-border-radius icon-image"
            >mdi-account</v-icon
          >
          <h2 class="mt-4">{{ userProfile.displayName }}</h2>

          <v-list>
            <v-divider class="mt-4" />
            <v-list-item @click="loadProfile(0)" class="py-2">
              <v-list-item-action-text><v-icon>mdi-account-edit</v-icon></v-list-item-action-text>
              <v-list-item-title class="text-left ml-3"><b>Profile</b></v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="loadProfile(2)">
              <v-list-item-action-text><v-icon>mdi-star-circle</v-icon></v-list-item-action-text>
              <v-list-item-title class="text-left ml-3"><b>Badges</b></v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="loadProfile(1)">
              <v-list-item-action-text
                ><v-icon>mdi-message-text-outline</v-icon></v-list-item-action-text
              >
              <v-list-item-title class="text-left ml-3"><b>Communication</b></v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="downloadTerms">
              <v-list-item-action-text><v-icon>mdi-note-text</v-icon></v-list-item-action-text>
              <v-list-item-title class="text-left ml-3"
                ><b>Terms and Conditions</b></v-list-item-title
              >
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="downloadPrivacyPolicy">
              <v-list-item-action-text><v-icon>mdi-note-text</v-icon></v-list-item-action-text>
              <v-list-item-title class="text-left ml-3"><b>Privacy Policy</b></v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="gdprRequest">
              <v-list-item-action-text><v-icon>mdi-email</v-icon></v-list-item-action-text>
              <v-list-item-title class="text-left ml-3"><b>GDPR Request</b></v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item class="py-2" @click="logout">
              <v-list-item-action-text class="hidden"
                ><v-icon>mdi-tablet-dashboard</v-icon></v-list-item-action-text
              >
              <v-list-item-title class="text-left ml-3"><b>Logout</b></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <!-- Must stay inside the drawer: v-navigation-drawer only treats clicks in a
           detached overlay as "inside" when that overlay is a descendant component. -->
      <GdprRequestDialog v-model="gdprDialog" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OnboardingService from "@/services/OnboardingService.js";
import GdprRequestDialog from "@/components/GdprRequestDialog.vue";
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";

export default {
  components: { GdprRequestDialog, DrawerToolbar },
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      gdprDialog: false,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    isOpen: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    profileImageHeight() {
      var size = this.$vuetify.breakpoint.name;
      if (size == "xs") {
        return 100;
      } else if (size == "sm") {
        return 120;
      } else {
        return 150;
      }
    },
    profileImageWidth() {
      var size = this.$vuetify.breakpoint.name;
      if (size == "xs") {
        return 100;
      } else if (size == "sm") {
        return 120;
      } else {
        return 150;
      }
    },
  },
  methods: {
    loadProfile(tab) {
      // We have to check if we're already on the router. If so, we just close the profile
      if (this.$route.name == "profile") {
        // We close the wallet
        this.$store.dispatch("setDisplayWalletMenu", false);
        // We also update the profile tab
        this.$store.dispatch("setProfilePageTab", tab);

        this.isOpen = false;
      } else {
        this.$router.push({
          name: "profile",
          params: { initialPageIndexToLoad: tab },
        });
      }
    },
    downloadTerms() {
      OnboardingService.downloadLegalDoc("terms");
    },
    downloadPrivacyPolicy() {
      OnboardingService.downloadLegalDoc("privacy");
    },
    gdprRequest() {
      this.gdprDialog = true;
    },
    logout() {
      this.$auth.logout({ returnTo: window.location.origin });
    },
  },
};
</script>

<style scoped>
.profile-picture {
  border: 2px solid;
  border-color: var(--v-grey-base);
}
.icon-image {
  height: 150px;
  width: 150px;
}
</style>
